import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('misel_token');
    const stored = localStorage.getItem('misel_user');
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
      } catch { /* ignore */ }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { token, user: userData } = res.data;
    localStorage.setItem('misel_token', token);
    localStorage.setItem('misel_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  }, []);

  const register = useCallback(async (data) => {
    const res = await api.post('/auth/register', data);
    const { token, user: userData } = res.data;
    localStorage.setItem('misel_token', token);
    localStorage.setItem('misel_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('misel_token');
    localStorage.removeItem('misel_user');
    setUser(null);
    window.location.href = '/en';
  }, []);

  const clearResetFlag = useCallback(() => {
    if (user) {
      const updated = { ...user, must_reset_password: false };
      setUser(updated);
      localStorage.setItem('misel_user', JSON.stringify(updated));
    }
  }, [user]);

  const mustResetPassword = Boolean(user?.must_reset_password);
  const isAdmin = user?.roles?.some(r => ['super_admin', 'owner_director', 'admissions', 'secretary', 'finance', 'academic_coordinator', 'instructor', 'marketing', 'support'].includes(r));
  const isStudent = user?.roles?.includes('student');
  const isApplicant = user?.roles?.includes('applicant');

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, clearResetFlag, mustResetPassword, isAdmin, isStudent, isApplicant }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
